import { useState } from 'react';

import type { ProtocolResponse } from 'generated/index';

/**
 * Whether the drawer is open, and for which protocol. The protocol is kept while the drawer slides
 * shut, so its title does not flip from "edit" to "new" during the animation.
 */
export const useProtocolDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [protocol, setProtocol] = useState<ProtocolResponse>();

  const open = (protocolToEdit?: ProtocolResponse) => {
    setProtocol(protocolToEdit);
    setIsOpen(true);
  };

  return {
    isOpen,
    protocol,
    openCreate: () => open(),
    openEdit: (protocolToEdit: ProtocolResponse) => open(protocolToEdit),
    close: () => setIsOpen(false)
  };
};
